<template>
    <div>
        <SkeletonLoader v-if="isLoading" :skeleton-data="skeletonData"/>
        <template v-else>
            <h4>Uzņēmuma pamatinformācija</h4>
            <CompaniesBaseForm :current-company="currentCompany"/>
            <hr/>
            <div class="row d-flex">
                <div class="col-sm-12 py-4">
                        <JobTitles/>
                </div>
            </div>
            <div v-if="currentUser.isAdmin" class="row d-flex">
                <div class="col-sm-6 py-4">
                    <UsersGroups/>
                </div>
                <div class="col-sm-6 py-4">
                    <Categories/>
                </div>
            </div>
            <Users/>
        </template>
    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';

    import CompaniesBaseForm from '@/components/companies/CompaniesBaseForm';
    import Users from '@/components/users/Users';
    import UsersGroups from '@/components/users-groups/UsersGroups';
    import Categories from '@/components/categories/Categories';
    import JobTitles from '@/components/job-titles/JobTitles';
    import SkeletonLoader from '@/components/global/skeleton-loader/SkeletonLoader';
    import {SkeletonLoaderRepository} from '@/components/global/skeleton-loader/SkeletonLoaderRepository';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';

    export default {
        name: 'company',
        components: {CompaniesBaseForm, SkeletonLoader, Users, Categories, UsersGroups, JobTitles},
        data: () => ({skeletonData: SkeletonLoaderRepository.singleCompanyLayout}),
        async created() {
            const companyId = this.currentUser.isAdmin ? this.$route.params.companyId : this.currentUser.company._id;
            const currentCompany = await this.getSingleCompany(companyId);

            if (!currentCompany._id) {
                this.$router.push({name: 'index'});
            }
        },
        methods: {
            ...mapActions('company', {
                /** @type {function|*} */
                getSingleCompany: companyStoreTypes.ACTION_GET_SINGLE_COMPANY,
            })
        },
        computed: {
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
                /** @type {boolean|*} */
                isLoading: companyStoreTypes.GET_IS_LOADING,
            }),
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
        },
    }
</script>